<section [formGroup]="stepForm">
  <div
    *ngIf="isRestoreFileDatabase"
    [attr.data-e2e]="elementsSelector.name.fileDatabaseBlock">
    <mbs-form-group>
      <mbs-destination-folder-input
        [buttonId]="'destination-db-step-file-destination-folder-tree'"
        [control]="destinationFolderControl"
        [destinationFolderParams]="destinationFolderParams"
        [disabledSelf]="destinationFolderControl.disabled"
        [hasTargetComputer]="!!mainService?.targetComputerData"
        [inputId]="'destination-db-step-file-destination-folder'"
        [isUnix]="isUnix"
        [label]="'wizards:destinationOld.destFolderDBLabel'"
        [name]="'destination-db-step-file-destinationFolder'"
        [placeholder]="destinationFolderParams?.dataForPath?.isUnix ? '/home' : 'C:\\Folder Name'"></mbs-destination-folder-input>
    </mbs-form-group>
    <mbs-form-group>
      <mbs-switcher
        formControlName="createFolder"
        [id]="'create-folder-switcher'"
        [label]="'wizards:createFolder' | i18next"></mbs-switcher>
    </mbs-form-group>
    <mbs-form-group>
      <mbs-input
        formControlName="backupTemplate"
        name="backupTemplate"
        [id]="'backup-template-1'"
        [label]="'wizards:backupTemplate' | i18next"
        [validationWhitespace]="true"></mbs-input>
    </mbs-form-group>
  </div>

  <div
    *ngIf="isRestoreDatabase"
    [attr.data-e2e]="elementsSelector.name.databaseBlock">
    <mbs-form-group>
      <mbs-destination-folder-input
        [buttonId]="'destination-db-step-destination-folder-tree'"
        [control]="destinationFolderControl"
        [destinationFolderParams]="destinationFolderParams"
        [disabledSelf]="destinationFolderControl.disabled"
        [hasTargetComputer]="!!mainService?.targetComputerData"
        [inputId]="'destination-db-step-destination-folder'"
        [isUnix]="isUnix"
        [label]="'wizards:destinationOld.destFolderDB2Label'"
        [name]="'destination-db-step-destinationFolder'"
        [placeholder]="destinationFolderParams?.dataForPath?.isUnix ? '/home' : 'C:\\Folder Name'"></mbs-destination-folder-input>
    </mbs-form-group>
    <mbs-form-group>
      <mbs-destination-folder-input
        [buttonId]="'destination-db-step-destination-folder-log-tree'"
        [control]="destinationFolderLogControl"
        [destinationFolderParams]="destinationFolderParams"
        [disabledSelf]="destinationFolderLogControl.disabled"
        [hasTargetComputer]="!!mainService?.targetComputerData"
        [inputId]="'destination-db-step-destination-folder-log'"
        [isUnix]="isUnix"
        [label]="'wizards:destinationOld.destFolderDBLogLabel'"
        [name]="'destination-db-step-destinationFolderLog'"
        [placeholder]="destinationFolderParams?.dataForPath?.isUnix ? '/home' : 'C:\\Folder Name'"></mbs-destination-folder-input>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-input
        formControlName="backupTemplate"
        name="backupTemplate"
        [id]="'file-name-template'"
        [label]="'wizards:fileNameTemplate' | i18next"
        [validationWhitespace]="true"></mbs-input>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-switcher
        formControlName="closeConnection"
        [id]="'close-connection-checkbox'"
        [label]="'wizards:closeConnection' | i18next"></mbs-switcher>
    </mbs-form-group>

    <mbs-destination-table
      [dataForItems]="itemsData"
      [forceValidate]="forceValidate"
      [isVirtual]="isVirtual"
      [loadingTableData]="loadingTableData"
      [ngModelOptions]="{ standalone: true }"
      [planType]="planType"
      [showState]="true"
      [(ngModel)]="overwriteAndSpecific"
      (ngModelChange)="overwriteAndSpecificChangeHandler($event)"></mbs-destination-table>
  </div>
</section>
